export default class BulkAction {
  constructor(options = {}) {
    this.target_store = $(options.target);
    this.action_zone = $(options.action);
    let secondary_nav_selector = options.secondary_nav || "#primary-subnav";
    this.secondary_nav = $(secondary_nav_selector);
    this.checked_scope = options.checked_scope || "div";
    this.selectedAll = false;
    this.bindHandlers();
  }

  _newCheckedValue(cur) {
    if (cur) {
      return "checked";
    } else {
      return false
    }
  }

  // Fill in the target_store with the comma separated values.
  fillTargetStore() {
    let ids = [];
    $.each($(`.js-bulk-collection ${this.checked_scope} input[type='checkbox']:checked`), (_, ele) => {
      ids.push($(ele).data("bulkid"));
    });
    this.target_store.val(ids.join(","));
    return ids.length;
  }

  handleBulkItemSelected(checkEle) {
    // A bit of a hack, this event gets triggered on the
    // label element, not on the parent div.
    let ele = $("input[type='checkbox']", $(checkEle).closest(this.checked_scope));
    let newChecked = this._newCheckedValue(!ele.is(":checked"));
    // Manually update the checkbox state =\
    ele.prop("checked", newChecked);

    let count = this.fillTargetStore();

    this.render(count);
  }

  bindHandlers() {
    N2.bindHandler("click", ".js-bulk-action", (e) => {
      e.preventDefault();
      if ($(e.currentTarget).attr("disabled")) {
        return false;
      }
      this.handleBulkItemSelected(e.currentTarget);
    });

    N2.bindHandler("click", ".js-bulk-action-cancel", () => {
      this.target_store.val("");
      $(`.js-bulk-collection ${this.checked_scope} input[type='checkbox']`)
        .prop("checked", false);
      $(".js-bulk-select-all").prop("checked", false);
      this.render(0);
    });

    N2.bindHandler("click", ".js-bulk-select-all", (e) => {
      if ($(e.currentTarget).attr("disabled")) {
        return false;
      }
      this.selectedAll = !this.selectedAll;
      let newChecked = this._newCheckedValue(this.selectedAll);
      $("input[type='checkbox']:not(:disabled)", $(this).parentNode).prop("checked", newChecked);

      let ids = [];
      $.each($(".js-bulk-collection input[type='checkbox']:not(:disabled)"), (_, ele) => {
        $(ele).prop("checked", newChecked);
        ids.push($(ele).data("bulkid"));
      });

      let count = this.fillTargetStore();

      this.render(count);
    });
  }

  render(count) {
    this.updateBulkCount(count);
    this.toggleTargetZone(count > 0);
    this.toggleSecondaryNav(count == 0);
  }

  updateBulkCount(count) {
    $(".bulk-action-count", this.action_zone).text(count);

    let textNode = $(".bulk-action-text", this.action_zone);
    if (count == 1) {
      textNode.text(textNode.data("single"));
    } else {
      textNode.text(textNode.data("plural"));
    }
  }

  toggleTargetZone(on) {
    N2.toggleHidden(this.action_zone, on);
  }

  toggleSecondaryNav(on) {
    N2.toggleHidden(this.secondary_nav, on);
  }
}
